import React from "react"
import { GlobalProvider } from "./src/contexts/GlobalContext"
import Layout from "./src/components/Layout"

import("./src/fonts/fonts.css")
import("./src/styles/global.css")
import("aos/dist/aos.css")

export const wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>
}

export const wrapRootElement = ({ element }) => (
  <GlobalProvider>{element}</GlobalProvider>
)
